__turbopack_context__.v({
  "hero": "styles-module-scss-module__GiG6Fa__hero",
  "hero--dark": "styles-module-scss-module__GiG6Fa__hero--dark",
  "hero--dark__text": "styles-module-scss-module__GiG6Fa__hero--dark__text",
  "hero--inverse": "styles-module-scss-module__GiG6Fa__hero--inverse",
  "hero--inverse__text": "styles-module-scss-module__GiG6Fa__hero--inverse__text",
  "hero--secondary": "styles-module-scss-module__GiG6Fa__hero--secondary",
  "hero--secondary__text": "styles-module-scss-module__GiG6Fa__hero--secondary__text",
  "hero__picture": "styles-module-scss-module__GiG6Fa__hero__picture",
  "hero__picture_disclosure": "styles-module-scss-module__GiG6Fa__hero__picture_disclosure",
  "hero__text": "styles-module-scss-module__GiG6Fa__hero__text",
  "progress-bar": "styles-module-scss-module__GiG6Fa__progress-bar",
  "section-product": "styles-module-scss-module__GiG6Fa__section-product",
});
